<template>
  <div class="overflow-x-auto">
    <table class="table-auto w-full mt-4" v-if="entries.length > 0">
      <thead>
        <tr>
          <th v-for="col in columns" :key="col.id" class="px-4 py-2 text-left">
            {{ col.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="customer in entries"
          :key="customer.id"
          class="hover:bg-neutral-100 transition-colors duration-150 ease-in-out"
        >
          <td v-for="col in columns" :key="col.id" class="border px-4 py-2">
            <a v-if="col.prop === 'name'" :href="'/users/' + encodeURIComponent(customer.handle)">{{ customer.name }}</a>
            <template v-else>{{ customer[col.prop] }}</template>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="text--center text--lighter pb-2" v-else>{{ $t('No Data') }}</p>
  </div>
</template>

<script>
export default {
  props: ["customers"],
  data: function () {
    return {
      columns: [
        { id: 1, prop: "name", label: this.$t("Name") },
        { id: 2, prop: "upvotes_received", label: this.$t("Upvotes received") },
        { id: 3, prop: "upvotes_given", label: this.$t("Upvotes given") },
        { id: 4, prop: "comments_count", label: this.$t("Comments count") },
      ],

      entries: this.customers,
    };
  },
};
</script>
